import type { FontSizeRange } from '../../types'
import { MIN_FONT_SIZE, MAX_FONT_SIZE } from '../../constants'

/**
 * Валидация и ограничение размера шрифта в диапазоне 4-18px
 */
export function clampFontSize(size: number): FontSizeRange {
    if (size < MIN_FONT_SIZE) {
        return MIN_FONT_SIZE
    }
    if (size > MAX_FONT_SIZE) {
        return MAX_FONT_SIZE
    }
    return Math.round(size) as FontSizeRange
}

/**
 * Валидация размера шрифта
 * @param size - размер шрифта
 * @returns валидированный размер шрифта
 */
export function validateFontSize(size: number): FontSizeRange {
    return clampFontSize(size)
}
